import { ComplexBundle } from "../../../types/Product.ts";

interface Props {
  step: ComplexBundle.Step;
  stepIndex: number;
  entry: ComplexBundle.Entry;
  entryIndex: number;
}

export const InformativeText = ({ entry }: Props) => {
  return (
    <div className="text-center rounded bg-blue-100 p-3">
      {entry.entry_name}
    </div>
  );
};
